<template>
  <div class="row m-0 pl-sm-0 pl-md-4" style="background-color:#fff">
    <div class="col-sm-12 col-md-9 pt-sm-2 pt-md-5">
      <h1>DX Cost-Effectiveness Analysis</h1>
      <table
        id="d2"
        class="table table-sm table-borderless"
        style="font-size:0.9em;margin-top:10px"
      >
        <thead>
          <tr>
            <th scope="col" style="width:50%" class="border-right"></th>
            <th scope="col" style="width:15%">DX</th>
            <th scope="col" style="width:15%" class="border-right">PLB</th>
            <th scope="col" style="width:20%" class="text-center">
              <span class="d-inline d-md-none">Incr.</span>
              <span class="d-none d-md-inline">Incremental</span>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr style="background-color:#f6f6fd">
            <th scope="row" class="border-right">Total costs €</th>
            <td> {{ this.totalCosts[0] | thousands }}</td>
            <td class="border-right">{{ this.totalCosts[1] | thousands }}</td>
            <td class="text-center">{{ this.totalCosts[2] | thousands }}</td>
          </tr>
          <tr class="border-bottom">
            <td class="border-right">Active treatment
              <span class="d-inline d-md-none">
                <small>(DX)</small>
              </span>
              <span class="d-none d-md-inline">
                <small>(Drugname)</small>
              </span>
            </td>
            <td>{{ this.dx[0] | thousands }}</td>
            <td class="border-right">{{ this.dx[1] | thousands }}</td>
            <td class="text-center">{{ this.dx[2] | thousands }}</td>
          </tr>
          <tr>
            <td class="border-right">Direct medical</td>
            <td>{{ this.totalCare[0] | thousands }}</td>
            <td class="border-right">{{ this.totalCare[1] | thousands }}</td>
            <td class="text-center">{{ this.totalCare[2] | thousands }}</td>
          </tr>
          <tr>
            <td class="border-right" style="padding-left:20px">
              <small>Outpatient</small>
            </td>
            <td>
              <small>{{ this.outpatient[0] | thousands }}</small>
            </td>
            <td class="border-right">
              <small>{{ this.outpatient[1] | thousands }}</small>
            </td>
            <td class="text-center">
              <small>{{ this.outpatient[2] | thousands }}</small>
            </td>
          </tr>
          <tr>
            <td class="border-right" style="padding-left:20px">
              <span class="d-inline d-md-none">
                <small>Other health prof.</small>
              </span>
              <span class="d-none d-md-inline">
                <small>Other health professionals</small>
              </span>
            </td>
            <td>
              <small>{{ this.other[0] | thousands }}</small>
            </td>
            <td class="border-right">
              <small>{{ this.other[1] | thousands }}</small>
            </td>
            <td class="text-center">
              <small>{{ this.other[2] | thousands }}</small>
            </td>
          </tr>
          <tr>
            <td class="border-right" style="padding-left:20px">
              <small>Hospitalization</small>
            </td>
            <td>
              <small>{{ this.hospitalization[0] | thousands }}</small>
            </td>
            <td class="border-right">
              <small>{{ this.hospitalization[1] | thousands }}</small>
            </td>
            <td class="text-center">
              <small>{{ this.hospitalization[2] | thousands }}</small>
            </td>
          </tr>
          <tr>
            <td class="border-right" style="padding-left:20px">
              <small>Antidepressants</small>
            </td>
            <td>
              <small>{{ this.antidepressant[0] | thousands }}</small>
            </td>
            <td class="border-right">
              <small>{{ this.antidepressant[1] | thousands }}</small>
            </td>
            <td class="text-center">
              <small>{{ this.antidepressant[2] | thousands }}</small>
            </td>
          </tr>
          <tr class="border-bottom">
            <td class="border-right" style="padding-left:20px;">
              <small>Other drugs</small>
            </td>
            <td>
              <small>{{ this.otherDrugs[0] | thousands }}</small>
            </td>
            <td class="border-right">
              <small>{{ this.otherDrugs[1] | thousands }}</small>
            </td>
            <td class="text-center">
              <small>{{ this.otherDrugs[2] | thousands }}</small>
            </td>
          </tr>
          <tr>
            <td class="border-right">Indirect medical
              <span class="d-inline d-md-none">
                <small>(Leave)</small>
              </span>
              <span class="d-none d-md-inline">
                <small>(Sick leave)</small>
              </span>
            </td>
            <td>{{ this.leave[0] | thousands }}</td>
            <td class="border-right">{{ this.leave[1] | thousands }}</td>
            <td class="text-center">{{ this.leave[2] | thousands }}</td>
          </tr>
          <tr style="background-color:#f6f6fd">
            <th class="border-right" scope="row">QALYs</th>
            <td>{{ this.QALY[0] | thousands }}</td>
            <td class="border-right">{{ this.QALY[1] }}</td>
            <td class="text-center">{{ this.QALY[2] }}</td>
          </tr>
          <tr class="border-bottom">
            <td scope="row">
              <strong>ICER €</strong>
              <small>(Per QALY gained)</small>
            </td>
            <td></td>
            <td class="border-right"></td>
            <td class="text-center">
              <strong>{{ this.ICER | thousands }}</strong>
            </td>
          </tr>
        </tbody>
      </table><br>
      <div class="row">
        <div class="col-sm-12 col-md-6">
          <p align="center"><strong>Costs</strong></p>
          <BarChart id="cost" />
        </div>
        <div class="col-sm-12 col-md-6">
          <p align="center"><strong>QALY</strong></p>
          <QALYChart id="QALY" />
        </div>
      </div>
      <br><br><br><br>
    </div>
    <div class="col-sm-12 col-md-3 pt-md-5 col-control">
      <form>
        <div class="row">
          <div class="col form-group">
            <div class="row">
              <div class="col" style="padding-top:7px">
                <select
                  class="custom-select form-control form-control-sm"
                  style="font-weight:bold; height:35px; font-size:16px"
                  v-model="timeHorizon"
                >
                  <option value="2" selected>1 year</option>
                  <option value="4">2 years</option>
                  <option value="10">5 years</option>
                  <option value="20">10 years</option>
                </select>
              </div>
            </div>
            <div class="row px-1" id="costRow1">
              <div class="col mt-3" style="font-size:0.8em">
                <label for="costDiscount">
                  <strong>Cost discount:
                    <span id="costDiscountLabel">{{ this.costDiscount }}</span>
                  </strong>
                </label>
                <input
                  type="range"
                  class="custom-range"
                  min="0"
                  max="25"
                  step="0.5"
                  v-model="costDiscount"
                  id="costDiscount"
                >
              </div>
            </div>
            <div class="row px-1" id="qalyRow">
              <div class="col mt-3" style="font-size:0.8em">
                <label for="effectDiscount">
                  <strong>Effect discount:
                    <span id="effectDiscountLabel">{{ this.effectDiscount }}</span>
                  </strong>
                </label>
                <input
                  type="range"
                  class="custom-range"
                  min="0"
                  max="25"
                  step="0.5"
                  id="effectDiscount"
                  v-model="effectDiscount">
              </div>
            </div>
            <div id="costRow3">
              <div class="row px-1 d-block">
                <div class="col mt-3">
                  <div class="custom-control custom-checkbox">
                    <input
                      type="checkbox"
                      class="custom-control-input"
                      id="customCheck1"
                      v-model="exclude"
                    >
                    <label
                      class="custom-control-label"
                      for="customCheck1"
                      style="font-size:0.8em;padding-top:3px"
                    >
                      <strong>Exclude indirect costs</strong>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>
<script>

import BarChart from '../components/BarChart.vue';
import QALYChart from '../components/QALYChart.vue';

export default {
  name: "Model",
  components: { BarChart, QALYChart },
  data() {
    return {
      title: "Model",
      timeHorizon: 2,
      effectDiscount: 4.5,
      costDiscount: 1.5,
      exclude: false
    };
  },
  computed: {
    model() {
      return this.$store.getters.getCEAModel.model;
    },
    dx() {
      var dx = [];
      this.model.dx.forEach(element => {
        dx.push(Number(element.toFixed(0)));
      });
      return dx; 
    },
    outpatient() {
      var outpatient = [];
      this.model.outpatient.forEach(element => {
        outpatient.push(Number(element.toFixed(0)));
      });
      return outpatient;
    },
    other() {
      var other = [];
      this.model.other.forEach(element => {
       other.push(Number(element.toFixed(0)));
      });
      return other;
    },
    hospitalization() {
      var hospitalization = [];
      this.model.hospitalization.forEach(element => {
        hospitalization.push(Number(element.toFixed(0)));
      });
      return hospitalization;
    },
    antidepressant() {
      var antidepressant = [];
      this.model.antidepressant.forEach(element => {
        antidepressant.push(Number(element.toFixed(0)));
      });
      return antidepressant;
    },
    otherDrugs() {
      var otherDrugs = [];
      this.model.otherDrugs.forEach(element => {
        otherDrugs.push(Number(element.toFixed(0)));
      });
      return otherDrugs;
    },
    totalCare() {
      var totalCare = [];
      this.model.totalCare.forEach(element => {
        totalCare.push(Number(element.toFixed(0)));
      });
      return totalCare;
    },
    leave() {
      var leave = [];
      this.model.leave.forEach(element => {
        leave.push(Number(element.toFixed(0)));
      });
      return leave;
    },
    lifeYears() {
      var lifeYears = [];
      this.model.lifeYears.forEach(element => {
        lifeYears.push(Number(element.toFixed(0)));
      });
      return lifeYears; 
    },
    QALY() {
      var QALY = [];
      this.model.QALY.forEach(element => {
        QALY.push(Number(element.toFixed(3)));
      });
      return QALY; 
    },
    ICER() {
      return (Number(this.model.ICER.toFixed(0))); 
    },
    totalCosts() {
      var totalCosts = [];
      this.model.totalCosts.forEach(element => {
        totalCosts.push(Number(element.toFixed(0)));
      });
      return totalCosts; 
    }
  },
  filters: {
    thousands: function (value) {
      value = value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return value;
    }
  },
  mounted() {
      this.$store.commit('setExclude',this.exclude);
      this.$store.commit('setHorizon',this.timeHorizon);
      this.$store.commit('setEffectCost',this.effectDiscount);
      this.$store.commit('setCost',this.costDiscount);
  },
  watch: {
    exclude() {
      this.$store.commit('setExclude',this.exclude);
    },
    timeHorizon() {
      this.$store.commit('setHorizon',this.timeHorizon);
    },
    effectDiscount () {
      this.$store.commit('setEffectCost',this.effectDiscount);
    },
    costDiscount () {
      this.$store.commit('setCost',this.costDiscount);
    }
  }
};
</script>

<style lang="scss">
@import "../scss/bootstrap-custom.scss";
@import "../../node_modules/bootstrap/scss/bootstrap.scss";
</style>


// WEBPACK FOOTER //
// src/views/Model.vue